// extracted by mini-css-extract-plugin
export default {"constroles":"Controles_constroles__XQ1Ni","constroles__switch":"Controles_constroles__switch__dVfuM"};